import { defineStore } from "pinia";

export const useDefaultPaySectionStore = defineStore('defaultPaySection', {
    state: () => ({
        defaultPaySection: {},
        defaultPaySections: [],
    }),
    actions: {
        setDefaultPaySection(defaultPaySection) {
            this.defaultPaySection = defaultPaySection
        },
        setDefaultPaySections(defaultPaySections) {
            this.defaultPaySections = defaultPaySections
        },
        addDefaultPaySection(defaultPaySection) {
            this.defaultPaySections.unshift(defaultPaySection)
        },
        updateDefaultPaySection(defaultPaySection) {
            let index = this.defaultPaySections.findIndex(cl => cl.id === defaultPaySection.id)
            this.defaultPaySections.splice(index, 1, defaultPaySection)
        },
        deleteDefaultPaySection(defaultPaySection) {
            let index = this.defaultPaySections.findIndex(cl => cl.id === defaultPaySection.id)
            this.defaultPaySections.splice(index, 1)
        },
    },
});